import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'idp-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class IconComponent {
  @Input() icon = '';
  @Input() rotate = false;
}
